const API = process.env.REACT_APP_CBC_API_END_POINT || '';
const TOKEN = process.env.REACT_APP_CBC_TOKEN || ''; // fallback to empty string
const SUBDOMAIN = process.env.REACT_APP_CBC_SUBDOMAIN || '';
const defaultHeaders = {
  'Content-Type': 'application/json',
  ...(TOKEN && { Authorization: `Bearer ${TOKEN}` }),
};

// Generic fetch wrapper
const apiFetch = async (url, method = 'GET', body = null, timeout = 8000) => {
  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeout);

  const config = {
    method,
    headers: defaultHeaders,
    ...(body && { body: JSON.stringify(body) }),
  };

  try {
    const response = await fetch(`${API}${url}`, config);
    clearTimeout(id);
    return response;
  } catch (error) {
    clearTimeout(id);

    if (error.name === 'AbortError') {
      // eslint-disable-next-line
      console.error('⚠️ Request timed out');
      throw new Error('Timeout'); // <-- this is your uncaught error
    }

    throw error; // other fetch errors
  }
};

// Fetch white-label config
export const fetchWhitelabeling = (subdomain, appNameQuery) => {
  const finalSubdomain =
    subdomain && subdomain !== 'UNBRANDED'
      ? subdomain
      : SUBDOMAIN || 'UNBRANDED';

  return apiFetch(`/cbc/white_label/${finalSubdomain}?${appNameQuery}`);
};

// Fetch balance
export const fetchBalance = prn => {
  return apiFetch(`/cbc/cardholders/${prn}/balance`);
};

// Fetch transactions
export const fetchTransactions = (prn, page, limit, startDate, endDate) => {
  return apiFetch(
    `/cbc/cardholders/${prn}/transactions?page=${page}&limit=${limit}&start_date=${startDate}&end_date=${endDate}`
  );
};

// fetch authorizations
export const fetchAuthorizations = (prn) => {
  return apiFetch(
    `/cbc/cardholders/${prn}/authorizations`
  );
};